module.exports = __webpack_public_path__ + "img/ru_ru.f04699b8.png";